export const ROUTES = {
  MAIN: '/',
}
